import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRosa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 41,
	viewBox: "0 0 38 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4306 0.948474L2.81773 8.57198C2.03845 9.00899 1.39142 9.63708 0.941578 10.3932C0.49174 11.1493 0.254918 12.0069 0.254883 12.8798V28.1206C0.255806 28.9933 0.493379 29.8505 0.943769 30.606C1.39416 31.3616 2.04153 31.989 2.82093 32.4254L16.4306 40.052C17.2108 40.4888 18.0958 40.7187 18.9967 40.7187C19.8975 40.7187 20.7825 40.4888 21.5627 40.052L35.1788 32.4285C35.9582 31.9921 36.6056 31.3647 37.056 30.6091C37.5064 29.8536 37.744 28.9964 37.7449 28.1237V12.8798C37.744 12.0071 37.5064 11.15 37.056 10.3944C36.6056 9.63887 35.9582 9.01144 35.1788 8.57509L21.5627 0.948474C20.7825 0.511688 19.8975 0.281738 18.9967 0.281738C18.0958 0.281738 17.2108 0.511688 16.4306 0.948474Z",
			fill: "#DA2F20"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3939 19.3604L9.30225 20.8476C9.3581 21.5039 9.46982 22.1533 9.62343 22.7887L13.5126 21.3713C13.3869 20.7149 13.345 20.0376 13.3939 19.3604Z",
			fill: "#DA2430"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.2159 14.8148C23.6992 14.3679 23.1197 13.9839 22.4703 13.6836C18.672 11.9101 14.1404 13.558 12.3669 17.3633C12.2692 17.5798 12.1784 17.7962 12.1016 18.0127C11.8781 18.6551 11.7525 19.3114 11.7036 19.9677L11.6896 19.9747V19.9887L9.22486 20.8824L7.63987 21.462V21.455L7.59798 21.4689C7.44437 19.5209 7.77254 17.51 8.65231 15.6177C8.77101 15.3734 8.88971 15.129 9.02237 14.8916C11.934 9.47329 18.5533 7.20403 24.1321 9.85034C25.2842 10.395 26.3106 11.1141 27.1904 11.959C27.7839 12.5036 28.3076 13.1111 28.7684 13.7535L24.6768 15.2407C24.6558 15.2198 24.6349 15.1988 24.6139 15.1779L24.6 15.1848C24.4813 15.0592 24.3556 14.9335 24.2159 14.8148Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.82854 28.0741C6.96971 26.8802 6.34829 25.5326 5.99219 24.1152L9.88134 22.6978V22.7117L9.90927 22.7047C10.1118 23.7591 10.5237 24.7715 11.1312 25.6583C11.3616 25.9864 11.6199 26.3006 11.9062 26.5939L11.8923 26.6009C11.8992 26.6079 11.9132 26.6218 11.9202 26.6288L7.86345 28.13C7.84949 28.1091 7.83552 28.0881 7.82854 28.0741Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2666 27.0268C21.1579 28.3325 18.4557 28.5839 16.0468 27.4597C15.195 27.0617 14.4549 26.5241 13.8334 25.8887L9.74878 27.3759C9.75576 27.3899 9.76973 27.4039 9.77671 27.4178C10.9009 29.0238 12.43 30.3644 14.3082 31.2511C18.358 33.1713 22.9593 32.501 26.2899 29.9175C27.7841 28.8003 29.027 27.3131 29.8649 25.5116C30.7446 23.6194 31.0728 21.6085 30.9192 19.6674L30.8075 19.7093C30.8075 19.6884 30.8075 19.6674 30.8005 19.6465L26.7438 21.1477C26.6809 22.0414 26.4575 22.9352 26.0595 23.794C25.4311 25.1695 24.4466 26.2657 23.2666 27.0268Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.7843 16.1834L27.8472 16.1625C28.4895 17.4752 28.8805 18.9066 28.9923 20.3728L24.9076 21.8601C24.9076 21.8531 24.9076 21.8391 24.9076 21.8322L24.8308 21.8601C24.9425 20.3519 24.6004 18.8437 23.8882 17.545L27.7494 16.1206C27.7634 16.1346 27.7704 16.1555 27.7843 16.1834Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4004 19.3394L9.33667 20.8406C9.38555 21.5039 9.50558 22.1611 9.65919 22.8035L13.5191 21.3712C13.3934 20.7009 13.3445 20.0236 13.4004 19.3394Z",
			fill: "#E1E1E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4452 14.9224C31.1475 14.2745 30.7442 13.6066 30.3672 13.062L26.3035 14.5632C26.7783 15.052 27.1592 15.6862 27.4873 16.2797L31.4452 14.9224Z",
			fill: "#E1E1E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.3373 20.8406L13.3983 19.3359C13.3983 19.3359 13.3808 19.5986 13.3808 19.765C13.3808 19.9314 13.3808 20.1678 13.3808 20.1678L9.4317 21.6651C9.4317 21.6651 9.40543 21.5425 9.3704 21.2623C9.33538 20.9821 9.33032 20.8406 9.33032 20.8406H9.3373Z",
			fill: "#B9B9B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3035 14.5564L30.3682 13.0576C30.3682 13.0576 30.4908 13.2327 30.6046 13.4166C30.7184 13.6005 30.8323 13.7844 30.8323 13.7844L26.8481 15.1988L26.3035 14.5564Z",
			fill: "#B9B9B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.76807 27.4075L13.836 25.8857C13.836 25.8857 14.2739 26.2973 14.4928 26.4724C14.7117 26.6475 15.1933 26.9924 15.1933 26.9924L10.8015 28.6852C10.8015 28.6852 10.5524 28.4514 10.2372 28.0486C9.92194 27.6458 9.76807 27.4075 9.76807 27.4075Z",
			fill: "#E1E1E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.9196 19.6074L26.7503 21.1478L26.4431 22.7957L30.9547 21.2274C30.9547 21.2274 30.9634 20.772 30.9547 20.413C30.9459 20.054 30.9196 19.6074 30.9196 19.6074Z",
			fill: "#E1E1E1"
		})
	]
});
export default SvgRosa;
